import React, { useState, useRef } from "react";
import { IoIosArrowDown } from "react-icons/io";
import { Link } from "react-router-dom";
import ChildCategories from "./ChildCategories";
import style from "./Category.module.css";

const ParentCategory = ({ category }) => {
    const { id, name, slug, childCount } = category || {};
    const [open, setOpen] = useState(false);
    const [rect, setRect] = useState(null);
    const ref = useRef(null);
    let timer;

    const handleMouseEnter = () => {
        clearTimeout(timer);
        if (ref.current) {
            setRect(ref.current.getBoundingClientRect());
        }
        setOpen(true);
    };

    const handleMouseLeave = () => {
        timer = setTimeout(() => setOpen(false), 200); // delay close
    };

    return (
        <li
            ref={ref}
            className={style.parent}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <div className="py-4 px-2 text-[13.5px] font-semibold hover:text-[#292d60] duration-300 flex space-x-2 items-center cursor-pointer">
                <Link to={`/${slug}/courses`}>{name}</Link>
                {childCount > 0 && <IoIosArrowDown className={style.arrowbutton} />}
            </div>

            {open && childCount > 0 && (
                <ChildCategories parentId={id} anchorRect={rect} />
            )}
        </li>
    );
};

export default ParentCategory;
